import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function PainPoints() {
  const points = ['Perdés todos los domingos buscando material y el lunes llegás con algo improvisado.', 'Pacientes con perfiles complejos (TEA, psicosis, gerontología, discapacidad) sin protocolo diferenciado para cada uno.', 'El 60% de los casos se complican porque no hay documentación clínica sólida que respalde tu intervención.', 'No podés justificar un aumento de honorarios porque no tenés un sistema profesional visible.'];
  return <section className="py-20 px-4 bg-dark-card/30 border-y border-dark-border pt-[15px] pb-[15px]" data-id="element-186">
      <div className="max-w-3xl mx-auto space-y-[16px]" data-id="element-187">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-188">
          <h2 className="text-3xl md:text-5xl font-black mb-6" data-id="element-189">
            ¿Cuántos domingos más vas a perder haciendo lo mismo?
          </h2>
          <p className="text-base text-gray-400" data-id="element-190">
            Si sos AT en Argentina, esto te va a sonar familiar.
          </p>
          <p className="text-xl font-bold text-brand mt-[24px] mb-[-30px]" data-id="element-191">
            No es falta de vocación. Es falta de un sistema.
          </p>
        </motion.div>

        <div className="space-y-2 mb-12" data-id="element-192">
          {points.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-center space-x-3 bg-dark-card border border-dark-border px-3 py-2 rounded-lg" data-id="element-193">
              <div className="bg-red-500/20 p-0.5 rounded-full shrink-0" data-id="element-194">
                <X className="w-4 h-4 text-red-500" data-id="element-195" />
              </div>
              <p className="text-gray-300 text-base" data-id="element-196">{point}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-197"></motion.div>
      </div>
    </section>;
}